import { passCodes } from '../passCodes';
import track9 from '../../../../assets/audio/tracks/track9.mp3';

const hints = [
    {
        text: 'Nesoustřeďte se na to, co tu je, ale co tu chybí.',
    },
    {
        text: 'Doplňte vždy písmeno co vám ve slově chybí, vzniknou vám římská čísla, která jednoduše sečtete.',
    },
    {
        text: 'X je 10, V je 5, I je 1, slova jsou peroxid, taxi, indián ...',
    },
    {
        text: 'Kódem je: 49',
        solution: true,
    },
];
export const step9house = {
    id: 9,
    title: '4. stanoviště',
    taskText: `
        <p>
            Asi to nebude jen tak, koukám že to po tobě chce nějakou další šifru. S tím já ti bohužel nepomůžu, kočky neumí číst. Já zatím budu šmejdit okolo.
        </p>
    `,
    audio: track9,
    snowAudio: track9,
    cipher: {
        text: `
            <span class="house-cipher">(pero_id, ta_i, _ndián) + (lu_us, mi_ér) + (pa_ián) + (L_po, zelen_na, cv_čit) = ?</span>
        `,
        label: 'Úkol',
    },
    catImage: 7,
    codeInputText: 'Zadejte výsledek',
    codeInputPassCodeRegexp: passCodes[5],
    additionalInfo: 'Odpovědí je číslo.',
    hints: hints,
    snowHints: hints,
};
